// extracted by mini-css-extract-plugin
export default {"countBadge":"countBadge_countBadge__lkbdh","bgBasic":"countBadge_bgBasic__Wr3EU","bgPrimary":"countBadge_bgPrimary__iJTD-"};